import React from 'react';
import { OptionProps, components } from 'react-select';
import { Option } from './SelectField';
import styles from './SelectField.module.scss';

export const OptionItem = (props: OptionProps<Option>) => {
  const {
    data: { label, icon },
  } = props;
  return (
    <components.Option {...props}>
      <div className={styles.option}>
        {icon && <img src={icon} />}
        {label}
      </div>
    </components.Option>
  );
};
